import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useLicenseStore = defineStore('license', () => {
  const { user } = storeToRefs(useAuthStore())
  const { fetchCoreExternalNoJson, fetchCmsRest } = useVgsFetch(user.value?.preferredLanguage)

  const isCheckingLicense = ref(false)
  const existingLicenses = ref(new Map<string, boolean>())

  const shouldShowLicenseAlert = computed(() => {
    /**
     * Returning false since we just redirect to home if no license is found for now.
    */
    return false
    // if (!isAtLicensedRoute.value || isCheckingLicense.value) return false
    // return !existingLicenses.value.get(route.params.subjectSlug as string)
  })

  const getPathStringForProduct = async (id: string) => {
    const response = await fetchCmsRest(`/content/objects/${id}/locations`)
    // returns /path/to/product
    return response?.LocationList.Location[0]._href.split('locations').pop()
  }

  const getProductLicense = (pathString: string) => {
    return fetchCoreExternalNoJson('/frontend/licenses/path?site=modus&pathstring=' + pathString)
  }

  const getHasAccess = async (pathString: string) => {
    if (!pathString) return false
    // Unncomment the if statement below to test the license check locally on "Innhold under utvikling"
    // if (pathString === '/1/2/265595/265596/275573/285625') return false

    // returns 403 if no access, all other status codes are considered access
    return (await getProductLicense(pathString)).status !== 403
  }

  const executeLicenseCheck = async (subjectParam: string | string[]) => {
    subjectParam = subjectParam as string
    if (!subjectParam) {
      throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
    }

    const hasCheckedLicense = existingLicenses.value.has(subjectParam)
    if (hasCheckedLicense)
      return existingLicenses.value.get(subjectParam)

    const contentId = subjectParam.split('_id:').pop()
    if (!contentId) {
      throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
    }

    let hasAccess
    try {
      isCheckingLicense.value = true
      const productPath = await getPathStringForProduct(contentId)
      hasAccess = await getHasAccess(productPath)
      existingLicenses.value.set(subjectParam, hasAccess)
    }
    finally {
      isCheckingLicense.value = false
    }

    return hasAccess
  }

  return { shouldShowLicenseAlert, executeLicenseCheck }
})
